import React from "react";
import classes from "./Logo.module.css";

const Logo = () => {
  return <h1 className={classes.Logo}> Dashboard</h1>;
};

export default Logo;
